export default "__VITE_ASSET__L8kWeoA0__"